import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, NgForm, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Company } from 'app/models/company.model';
import { ContainerEnum } from 'app/models/container.enum';
import { Container } from 'app/models/container.model';
import { Device } from 'app/models/device.model';
import { User } from 'app/models/user.model';
import { CompanyService } from 'app/services/company.service';
import { ContainerService } from 'app/services/container.service';
import { CoordinatesFromAddressService } from 'app/services/coordinates-from-address.service';
import { DeviceService } from 'app/services/device.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import { BaseFormComponent } from "../../base-form.component";
import { ContainerDeviceListComponent } from '../container-device-list/container-device-list.component';
import { Poligon, PoligonDetail } from './../../../../../models/poligon.model';
import { PoligonService } from './../../../../../services/poligon.service';
import { ContainerLocationFormComponent } from './../container-location-form/container-location-form.component';
import { cloneDeep } from 'lodash';

@Component({
    selector: 'app-container-form',
    templateUrl: './container-form.component.html',
    styleUrls: ['./container-form.component.scss']
})
export class ContainerFormComponent extends BaseFormComponent  implements OnInit {
    


    // Form operation type
    public operation: 'create' | 'update';
    
    public _changeDevice: string
    public companyId:number;
    public selectedCompany: number;
    public companyList: Array<Company>
    public selectedLocation: L.LatLng;
    public poligonList: Array<Poligon>
    public _containerEnum:ContainerEnum;
    public get containerEnum(): typeof ContainerEnum {
        return ContainerEnum; 
    }
    public get changeDevice() {
        return this._changeDevice
    }
    public set changeDevice(d: string) {
        this._changeDevice = d
    }
    
    public _selectedPoligon: number;
    public get selectedPoligon() {
        return this._selectedPoligon
    }
    public set selectedPoligon(v: number) {
        this._selectedPoligon = v
    }
    
    private _container: Container = {
        street: undefined,
        streetDesc: undefined,
        neighbor: undefined,
        rootType: undefined,
    }
    private _deviceList: Array<Device> = [];
    public get model() {
        return this._container
    }
    public set model(v: Container) {
        this._container = v;
    }
    public formDeadZone=new FormControl('',[(control:AbstractControl)=>Validators.max(this.model.altitude?parseInt(this.model.altitude):0)(control),Validators.required])
    constructor(
        private _containerService: ContainerService,
        private deviceService: DeviceService,
        private _dialog: MatDialog,
        private toasterService: ToasterService,
        @Inject(MAT_DIALOG_DATA) public data,
        private _coordinatesFromAddressService:CoordinatesFromAddressService,
        private _poligonService: PoligonService,
        private _companyService: CompanyService,
        private _translateService:TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        this.companyId = parseInt(localStorage.getItem("CompanyID"));
        this.model.status =true;
        this.getPoligonList(this.companyId);
        if (this.operation == "update") {
            try {
                var poligon = await this._poligonService.getByPoligonDetail(this.model.id);
                poligon.forEach(z => this.selectedPoligon = z.poligonId);
            } catch (error) {
                console.warn(error);

            }
            this.model = this.data;
            this.selectedCompany = this.model.companyId;
            this.getPoligonList(this.selectedCompany);

        }
        if (this.companyId == 1) {
            try {
                this.companyList = await this._companyService.getCompanies();

            } catch (error) {
                console.warn(error);

            }
        }
    }

    public async onCompanyChange(id){
        this.getPoligonList(id);
    }

    public async getPoligonList(companyId:number){
        try {
            this.poligonList = await this._poligonService.getPoligons(companyId);
        } catch (error) {
            console.warn(error);
        }
    }

    public async deviceSearch(deviceId,e) {
        if(e) {
            e.stopPropagation();
          }
          if(e && e.keyCode !== 13){
            return;
          }
          
        if (deviceId != "") {
            try {
                this._deviceList = await this.deviceService.getFilterDevice(deviceId, parseInt(localStorage.getItem("CompanyID")));
            } catch (error) {
                console.warn(error);

            }
            const dialog = this._dialog.open(ContainerDeviceListComponent, {
                data: { deviceList: this._deviceList, changeDevice: this._changeDevice },
                disableClose: false
            });
            dialog.afterClosed().subscribe(result => {
                if (result == undefined) {
                    return;
                }
                this._changeDevice = result.id;
            });
        }
    }

    public async save() {

        if (this._changeDevice == null) {
            this.toasterService.toastFail(this._translateService.instant("PLEASE_ADD_DEVICE"))
            return;
        }


        if (this.form.invalid) {
            this.toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }

        if(this.model.altitude<=this.model.deadZone){
            this.toasterService.toastWarning(
                this._translateService.instant("DEAD_ZONE_LESS_ALTITUDE")
            )
            return;
        }
        debugger;
        this.model.companyId = parseInt(localStorage.getItem("CompanyID")) === 1 ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"));
        this.model.company=null;
        this.model.status=true;

        this.model.dDate = new Date()
        this.model.deviceId = this._changeDevice
        let response;
        if (this.operation == "create") {
            try {
                response = await this._containerService.add(this.model)

            } catch (error) {
                console.warn(error);
                this.added.emit(false);
            }
            if (this.selectedPoligon != undefined) {
                let poligonDetail = new PoligonDetail();
                poligonDetail.discriminator = "container"
                poligonDetail.discriminatorId = response.id
                poligonDetail.poligonId = this.selectedPoligon;
                try {
                    await this._poligonService.addDetail(poligonDetail);
                    this.added.emit(true);
                } catch (error) {
                    console.warn(error);
                    this.added.emit(false);
                }
            }
            this.added.emit(true);
        }
        else {
            this.model.device=undefined;
            try {
                response = await this._containerService.updated(this.model);
            } catch (error) {
                console.warn(error);
            }
            if (this.selectedPoligon != undefined) {
                try {
                    var poligonByDetail = await this._poligonService.getByPoligonDetail(this.model.id)
                    await this._poligonService.removeRange(poligonByDetail)
                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);
                }
                let poligonDetail = new PoligonDetail();
                poligonDetail.discriminator = "container";
                poligonDetail.discriminatorId = this.model.id;
                poligonDetail.poligonId = this.selectedPoligon;
                try {
                    await this._poligonService.addDetail(poligonDetail);
                    this.updated.emit(true);
                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);
                }
            }
            this.updated.emit(true);
        }

    }

    public async getCoordinateFromAddress(){
        var address = await this._coordinatesFromAddressService.getAddress(this.model.latitude,this.model.longitude)
        if(address.address.town){
            this.model.neighbor = address.address.town;
            this.model.streetDesc = address.address.town
        }
        if(address.address.suburb){
            this.model.street = address.address.suburb
            if(this.model.streetDesc){
                this.model.streetDesc += (' / '+ address.address.suburb)
            }
            else{
                this.model.streetDesc = ( address.address.suburb)

            }
        }
        if(address.address.road){
            this.model.street += ((this.model.street?' / ':'') + address.address.road)
            this.model.streetDesc += (' / ' + address.address.road)

        }
    }

    public async containerLocation() {
        const dialog = this._dialog.open(ContainerLocationFormComponent, {
            disableClose: false,
        })
  
        dialog.afterClosed().subscribe(async result => {
            if (result != undefined) {
                this.model.latitude = result.lat;
                this.model.longitude = result.lng;
                await this.getCoordinateFromAddress();
            }
        })
    }

}
